import Vuex from 'vuex';
import Vue from 'vue';

import authStore from './modules/auth.js';
import modalStore from './modules/modal.js';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules : {
        authStore,
        modalStore
    },

    state(){
        return {
            snackbarOK : false,
            mensajeSnackbar : '',
            tipoSnackbar : 'INFO',
            routeLoading : false
        }
    },
    mutations : {
        openSnackbar(state, payload){
            state.snackbarOK = !state.snackbarOK,
            state.mensajeSnackbar = payload.mensaje || payload.message || '',
            state.tipoSnackbar = payload.tipo || payload.type || 'INFO'
        },
        setRouteLoading(state, value){
            state.routeLoading = value
        }
    },
    getters : {
        snackbarOK(state){
            return state.snackbarOK;
        },
        mensajeSnackbar(state){
            return state.mensajeSnackbar
        },
        tipoSnackbar(state){
            return state.tipoSnackbar
        },
        routeLoading(state){
            return state.routeLoading
        }
    },
    actions : {
        openSnackbar(context,payload){
            context.commit('openSnackbar', payload)
        }
    }
})

export default store;